import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import analytics from '@referrals/analytics';
import { requestCallbackSelector } from '~referral/selectors/referralCallback';
import Tick from '~referral/images/streak_shared_modal/tick.svg';
import { REFERRAL_TRACKING } from '@referrals/utils/trackingEvents';
import { scheduleCall } from '~referral/stores/referralCallback';
import {
  setReferralInfoModalState,
} from '~referral/stores/streakReferralModal';
import { Tappable } from '@common/ui/general';
import UpArrow from '~referral/images/referral_modal/green-arrow.svg';

const ReferralStateModal = ({
  translations,
  isEndState,
  hasUGAccess = false,
}) => {
  const dispatch = useDispatch();
  const {
    rcbSource,
  } = useSelector(requestCallbackSelector);

  const currentPagePath = window.location.pathname;
  const source = rcbSource || currentPagePath;

  const notNowClick = () => {
    dispatch(setReferralInfoModalState(false));
  };

  const knowMoreOnClick = () => {
    batch(() => {
      dispatch(setReferralInfoModalState(false));
      isEndState(true);
      dispatch(scheduleCall(source, notNowClick));
      analytics?.click(
        REFERRAL_TRACKING.clickKnowMore,
        'Nudge Happy flow Shared Modal', {
          pageSource: currentPagePath,
        },
      );
    });
  };

  return (
    <>
      <div className="rsm__container">
        <div className="rsm__title-container">
          <div className="rsm__logo-container">
            <img
              src={Tick}
              alt="tick"
              className="rsm__logo"
            />
          </div>
          <div className="rsm__title-content-container">
            <div className="rsm__title">
              Thank you!
            </div>
            <div className="rsm__title-content">
              We will credit your Scaler Coins upon verification.
              This may take up to 10 days.
            </div>
          </div>
        </div>
        <div className="rsm__content">
          <div className="rsm__content--left">
            <div className="rsm__content-arrow-container">
              <img
                alt="arrow"
                className="rsm__content-arrow-img"
                src={UpArrow}
              />
            </div>
            <div className="rsm__left-content-title">
              Your chance to
            </div>
            <div className="rsm__left-content">
              {
                hasUGAccess ? (translations?.goodiesContentSst) : (
                  translations?.goodiesContent
                )
              }
            </div>
          </div>
          <div className="rsm__content--right">
            <div>
              <div className="rsm__right-content-title">
                Since you posted on LinkedIn
              </div>
              <div className="rsm__right-content-list">
                <ol className="rsm__ol">
                  {
                    hasUGAccess ? (
                      translations?.postShareReferralInfoSst?.map(
                        (listItem, index) => (
                          <li key={index} className="rsm__li">
                            {listItem}
                          </li>
                        ))
                    ) : (
                      translations?.postShareReferralInfo?.map(
                        (listItem, index) => (
                          <li key={index} className="rsm__li">
                            {listItem}
                          </li>
                        ))
                    )
                  }
                </ol>
              </div>
            </div>
            <div>
              <Tappable
                href="/referral-terms/"
                target="_blank"
                className="rsm__right-tnc"
              >
                *T&amp;Cs Apply
              </Tappable>
              <div className="rsm__right-sub-content">
                Curious on how the referral process works ?
              </div>
              <div className="rsm__button-container">
                <Tappable
                  className="btn rsm__button--primary"
                  component="button"
                  onClick={knowMoreOnClick}
                >
                  Know more on a call
                </Tappable>
                <Tappable
                  className="btn rsm__button--secondary"
                  component="button"
                  onClick={notNowClick}
                >
                  Not now
                </Tappable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReferralStateModal;
